module.exports = __webpack_public_path__ + "img/bespoke70_09.cb9e4885.jpg";